import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectElements } from '../store/selectors';
import { BoxWithHandle } from './box-with-handle';

export const DraggableBoxes = ({
  filterText: controlledFilterText,
  onFilterTextChange,
  showFilterInput = true,
}) => {
  const elements = useSelector(selectElements);
  const [uncontrolledFilterText, setUncontrolledFilterText] = useState('');

  const filterText = controlledFilterText !== undefined ? controlledFilterText : uncontrolledFilterText;

  const setFilterText = value => {
    if (onFilterTextChange) onFilterTextChange(value);
    else setUncontrolledFilterText(value);
  };

  const filteredElements = (elements && Array.isArray(elements)) ? elements.filter(
    item =>
      // Filter out deleted elements
      !item.deleted &&
      (item.id?.toString().includes(filterText) ||
      item.title?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.description?.toLowerCase().includes(filterText.toLowerCase())),
  ) : [];

  return (
    <div className="task-board-shell">
      {showFilterInput && (
        <div className="input-blocks draggable-input-box-filter mb-3">
          <input
            type="text"
            placeholder="Enter task name or ID"
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            className="form-control"
            style={{
              height: '52px',
            }}
          />
        </div>
      )}
      <div className="task-board-items-scroll">
        {filteredElements.map(item => (
          <BoxWithHandle key={item.id} data={item} />
        ))}
      </div>
    </div>
  );
};
